// extracted by mini-css-extract-plugin
export default {"map":"styles_map__bgZgP","mapboxgl-map":"styles_mapboxgl-map__3vuXi","mapboxgl-canvas":"styles_mapboxgl-canvas__YhUqt"};